import { SvgIcon } from '@mui/material';

export const CloseTabs = props => {
  return (
    <SvgIcon {...props}>
      <g
        id="Group_360"
        data-name="Group 360"
        transform="translate(-35 -25.499)"
      >
        <g
          id="Rectangle_83"
          data-name="Rectangle 83"
          transform="translate(41 25.499)"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
        >
          <rect width="16" height="16" stroke="none" />
          <rect x="1" y="1" width="14" height="14" fill="none" />
        </g>
        <g
          id="Rectangle_85"
          data-name="Rectangle 85"
          transform="translate(35 30.499)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="2"
        >
          <rect width="17" height="17" stroke="none" />
          <rect x="1" y="1" width="15" height="15" fill="none" />
        </g>
        <path
          id="Icon_material-close"
          data-name="Icon material-close"
          d="M15.5,8.306,14.693,7.5,11.5,10.694,8.306,7.5,7.5,8.306,10.694,11.5,7.5,14.693l.806.806L11.5,12.3,14.693,15.5l.806-.806L12.3,11.5Z"
          transform="translate(31.79 27.711)"
          fill="#031b2c"
        />
      </g>
    </SvgIcon>
  );
};
